import React from 'react';

function FacebookIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}>
            <path
                d="M22 11.9397C21.9885 10.0313 21.4311 8.16597 20.3936 6.56408C19.3562 4.96219 17.882 3.69063 16.1452 2.89955C14.4084 2.10847 12.4814 1.83091 10.592 2.09964C8.70249 2.36838 6.92937 3.17218 5.48199 4.41615C4.03461 5.66011 2.97343 7.29227 2.42375 9.11989C1.87407 10.9475 1.85886 12.8943 2.3799 14.7302C2.90095 16.5662 3.93649 18.2148 5.36424 19.4812C6.792 20.7476 8.55234 21.5791 10.4374 21.8773V14.8481H7.8982V11.9389H10.4374V9.72388C10.4374 7.20303 11.9307 5.80718 14.2149 5.80718C14.9648 5.81764 15.713 5.88337 16.4533 6.00385V8.4847H15.1916C14.976 8.45681 14.757 8.47773 14.5506 8.54591C14.3442 8.6141 14.1558 8.72781 13.9993 8.87863C13.8428 9.02946 13.7222 9.21353 13.6464 9.41725C13.5707 9.62097 13.5417 9.83911 13.5616 10.0555V11.9422H16.3333L15.8899 14.8514H13.5566V21.8815C15.9167 21.5001 18.0635 20.2895 19.6112 18.4672C21.1588 16.645 22.0058 14.3305 22 11.9397V11.9397Z"/>
        </svg>
    );
}

export default FacebookIcon;